export default __webpack_public_path__ + "static/media/grafema_coimbra-2027-contest_04.e07cd34a.jpg";